export default __webpack_public_path__ + "static/media/newshop.aceccf29.png";